export const getMenuData = [
  {
    icon: 'mdi-timetable',
    title: 'Timetable',
    key: 'timetable',
    to: `/timetable`,
    enableCalendar: true,
  },
  {
    title: 'Profile',
    key: 'profiles',
    icon: 'mdi-account-box-outline',
    children: [
      {
        title: 'Clinic',
        key: 'clinicProfiles',
        to: `/clinicProfiles`,
        icon: 'mdi-hospital-building',
      },
      {
        title: 'Member',
        key: 'members',
        to: `/members`,
        icon: 'mdi-account-circle',
      },
      {
        title: 'Admin',
        key: 'admins',
        to: `/admins`,
        icon: 'mdi-account-tie',
      },
      {
        title: 'Staff',
        key: 'staff',
        to: `/staff`,
      },
      {
        title: 'Doctor',
        key: 'doctors',
        to: `/doctors`,
      },
    ],
  },
  {
    icon: 'mdi-bell-outline',
    title: 'Notification',
    key: 'notification',
    to: `/notification`,
  },
  {
    icon: 'mdi-newspaper-variant-outline',
    title: 'Booking',
    key: 'bookings',
    to: `/booking`,
  },
  {
    title: 'About Clinic',
    key: 'myClinic',
    to: `/myClinic`,
    icon: 'mdi-hospital-building',
  },
  {
    title: 'CMS',
    key: 'cms',
    icon: 'mdi-file-document-outline',
    children: [
      {
        title: 'Agreement',
        key: 'cmsAgreement',
        to: `/cms/agreement`,
        icon: 'mdi-file-sign',
      },
      {
        title: 'Terms and Condition',
        key: 'cmsTerms',
        to: `/cms/terms-and-condition`,
        icon: 'mdi-file-document-edit',
      },
    ],
  },
  { title: 'Setting', key: 'SystemConfig', to: `/SystemConfig`, icon: 'mdi-wrench-cog-outline' },
  {
    icon: 'mdi-account-remove',
    title: 'Account Deletion Requests',
    key: 'accountDeletionRequests',
    to: '/account-deletion-requests',
  },
  {
    title: 'Logout',
    key: 'logout',
    clickAction: `ssoLogout`,
    icon: 'mdi-logout',
  },
];
